const tiredFeelings = [
  'Ne pas préciser',
  'Fatigué.e',
  'Surmené.e',
  'Crevé.e',
  'Exténué.e',
];

export default tiredFeelings;
